import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MySocketWrapper } from './socket-wrapper';
import { urls } from 'src/app/utils/url.utils';
@Injectable({
  providedIn: 'root'
})
export class SocketService {

 constructor(private socket: MySocketWrapper) {

    this.socket.on('connect', (reason: any) => {
      
		});

		this.socket.on('disconnect', (reason: any) => {
		});
   }
  
  getSocket() {
    return this.socket;
  }

  emit(event: any, payload?: any) {
   
    this.socket.emit(event, payload);
  }

  addListener(event: any): Observable<any> {
    return this.socket.fromEvent(event).pipe(
      map(data => {
 
        return data;
      })

    );

  }

  removeListener(event: any) {
    this.socket.removeListener(event, ()=> {
    });
  }


  connectSocket() {
    if (!this.socket.ioSocket.connected ) {
      const token = localStorage.getItem('access_token')
      if (token) {
        this.socket.ioSocket.io.opts.extraHeaders = {Authorization: `Bearer ${JSON.parse(token)}`} //new headers
      }
    // this.socket.ioSocket.io.opts.query = { auth_token: token ? JSON.parse(token) : ''} //new options
    this.socket.ioSocket.io.uri = urls.SERVER_URL //new uri
    this.socket.connect(); //manually connection
  
    }
  }

  disconnectSocket() {
    if (this.socket.ioSocket.connected){
      this.socket.removeAllListeners();
       this.socket.disconnect();
    }
  }
}
